import { formatters } from "@/helpers/formatters";
import { InputDictionary } from "@/types/common";

export default <InputDictionary[]>[
  // in plan module it's b2b_or_b2c
  {
    title: "B2B / B2C",
    value: "b2b_b2c",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
  {
    title: "Business Goal Object",
    value: "business_goal",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
  {
    title: "Business Goal",
    value: "business_goal_property_value",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
  {
    title: "Campaign KPI",
    value: "campaign_kpi",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
  {
    title: "Channel",
    value: "channel",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
  {
    title: "Channel Objective",
    value: "channel_objective",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
  {
    title: "Funnel Stage",
    value: "funnel_stage",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
  {
    title: "Media Type",
    value: "media_type",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
  {
    title: "Plan",
    value: "plan",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
  {
    title: "Scenario",
    value: "scenario",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
];
